import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { Toaster } from '@/components/ui/sonner';

// Pages
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import CoursesPage from '@/pages/CoursesPage';
import FacultyPage from '@/pages/FacultyPage';
import DirectorPage from '@/pages/DirectorPage';
import ResultsPage from '@/pages/ResultsPage';
import EnquiryPage from '@/pages/EnquiryPage';
import ContactPage from '@/pages/ContactPage';
import FAQsPage from '@/pages/FAQsPage';
import WhyChooseUsPage from '@/pages/WhyChooseUsPage';
import AdmissionPage from '@/pages/AdmissionPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import CourseDetailPage from '@/pages/CourseDetailPage';
import ScrollToTop from '@/components/common/ScrollToTop';
import PsatPopup from '@/components/common/PsatPopup';
import ScholarshipPin from '@/components/common/ScholarshipPin';
import ResultsGalleryPage from '@/pages/ResultsGalleryPage';
import ScholarshipPage from '@/pages/ScholarshipPage';
import StudyMaterialPage from '@/pages/StudyMaterialPage';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MainLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/director" element={<DirectorPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/enquiry" element={<EnquiryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
          <Route path="/admission" element={<AdmissionPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/courses/:courseId" element={<CourseDetailPage />} />
          <Route path="/gallery" element={<ResultsGalleryPage />} />
          <Route path="/study-material" element={<StudyMaterialPage />} />
          <Route path="/scholarship" element={<ScholarshipPage />} />
        </Routes>
      </MainLayout>
      <Toaster position="top-right" />
      <PsatPopup />
      <ScholarshipPin />
    </BrowserRouter>
  );
}

export default App;
